import { memo } from "react";
import { generatePath } from "react-router";

import { getHotelTopAboutUrl } from "@/lib/chillnn/get-detail-url";

import { PATHS } from "@/routes/paths";

import type { FeatureTabItemType } from "@/components/features/_layouts";
import { FeatureIslandHeaderAndTab } from "@/components/features/_layouts";

import OpenInNew from "@/components/ui/icon/open-in-new";

const tabArray = (hotelID: string) =>
	[
		{
			tabTitle: "施設記事",
			path: generatePath(PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.LIST.HOTEL, { hotelID }),
			tablet: true,
		},
		{
			tabTitle: "プラン記事",
			path: generatePath(PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.LIST.PLAN, { hotelID }),
			tablet: true,
		} satisfies FeatureTabItemType,
		{
			tabTitle: "部屋記事",
			path: generatePath(PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.LIST.ROOM, { hotelID }),
			tablet: true,
		},
		{
			tabTitle: "設定",
			path: generatePath(PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.SETTING, { hotelID }),
			tablet: true,
		},
		{
			tabTitle: "マガジンページ",
			path: getHotelTopAboutUrl(hotelID),
			tabTitleRightChildren: <OpenInNew size="sm" />,
			targetBlank: true,
			tablet: true,
		},
	] satisfies FeatureTabItemType[];

type Props = {
	hotelID: string;

	headerProps?: {
		rightChildren?: React.ReactNode;
	};
};

export const DesignMagazineHeaderAndTab = memo(({ hotelID, headerProps }: Props) => {
	const title = "マガジン記事の一覧";

	return (
		<FeatureIslandHeaderAndTab
			headerProps={{ title, rightChildren: headerProps?.rightChildren }}
			tabProps={{
				tabArray: tabArray(hotelID),
			}}
		/>
	);
});
